export const getDietDailyCostPerSetDay = (
  isTestOrder,
  sectorId,
  sectorsDietPrices
) => {
  const selectedDietPrices = sectorsDietPrices.find(
    prices => prices.sectorId === sectorId
  );
  return isTestOrder ? selectedDietPrices.testPrice : selectedDietPrices.price;
};

export const getDietDailyCostAfterDaysDiscountPerSetDay = (
  dietDailyCost,
  dayDiscount
) => {
  if (!dayDiscount?.discount) {
    return dietDailyCost;
  } else if (dayDiscount?.discountType === 'PERCENTAGE') {
    return dietDailyCost * (1 - dayDiscount?.discount / 100);
  } else if (dayDiscount?.discountType === 'TOTAL') {
    return dietDailyCost - dayDiscount?.discount;
  } else {
    return dietDailyCost;
  }
};
